'use client'

import React from 'react'
import { Sparkles, MessageCircle } from 'lucide-react'
import FAQAccordion from './FAQAccordion'
import Link from 'next/link'
import { Faqs } from '@/services/dataTypes'

const C = { PRIMARY: '#F8F246', SECONDARY: '#2CBBC3', BROWN: '#8C5826', TEXT: '#1a1a1a', MUTED: '#6b7280', LIGHT: '#E1F1F2' }

interface FAQ {
    question: string;
    answer: string;
}

interface Props {
    faqs?: FAQ[]
}

const FAQsSection = ({ faqs }: Props) => {
    if (!faqs?.length) return null

    return (
        <section
            className="py-20 px-6 relative overflow-hidden"
            style={{ background: '#ffffff' }}
            aria-labelledby="faq-heading"
        >
            <div className="max-w-4xl mx-auto relative">
                <div className="text-center mb-12">
                    <span
                        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-[0.18em] mb-4"
                        style={{ background: `${C.PRIMARY}12`, border: `1px solid ${C.PRIMARY}30`, color: C.BROWN }}
                    >
                        <Sparkles size={10} color={C.BROWN} /> FAQ
                    </span>

                    <h2
                        id="faq-heading"
                        className="text-4xl font-black mb-3"
                        style={{ color: C.TEXT }}
                    >
                        Frequently Asked{' '}
                        <span style={{ color: C.PRIMARY }}>Questions</span>
                    </h2>

                    <p className="text-sm mt-4" style={{ color: C.MUTED }}>
                        Everything you need to know about pet care deals.{' '}
                        <Link
                            href="/contact-us"
                            className="font-bold underline underline-offset-2 hover:opacity-70 transition-opacity"
                            style={{ color: C.BROWN }}
                        >
                            Contact us
                        </Link>{' '}
                        if you need more help.
                    </p>
                </div>

                <FAQAccordion faqs={faqs} />
            </div>
        </section>
    )
}

export default FAQsSection